<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    title="变动单价"
    width="50%"
    append-to-body
  >
    <div class="dialog-content">
      <el-form ref="priceRef" :model="priceInfo" :rules="formRule" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="变动单价" prop="temporaryPrice">
              <InputNumber
                min="0"
                max="99999999999999999"
                :precision="4"
                v-model="priceInfo.temporaryPrice"
              ></InputNumber>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="定价数量" prop="productQuantity">
              <InputNumber
                min="0"
                max="99999999999999999"
                :precision="8"
                v-model="priceInfo.productQuantity"
              ></InputNumber>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="cancelHandler" size="small">取消</el-button>
        <el-button type="primary" @click="confirmHandler" size="small">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import API from '@/api/purchaseSalesCenter/wumaoPurchaseSales.js';
  export default {
    name: 'BusinessDialog',
    data() {
      return {
        dialogVisible: false,
        priceInfo: {
          temporaryPrice: '',
          productQuantity: '',
        },
        formRule: {
          temporaryPrice: [
            { required: true, message: '变动单价不能为空', trigger: ['blur', 'change'] },
          ],
          productQuantity: [
            { required: true, message: '定价数量不能为空', trigger: ['blur', 'change'] },
          ],
        },
        materialTypeList: [],
      };
    },
    methods: {
      // openModal() {
      //   this.dialogVisible = true;
      // },
      openModal(row, pricingRule) {
        console.log(row.parentProductNo, '===>', row.productChName);
        console.log(row, '行数据');
        // if (overShippedPercentage) {
        //   this.max = this.$cal.calCommon(
        //     row.productQuantity,
        //     this.$cal.calCommon(1, this.$cal.calCommon(overShippedPercentage, 100, '/'), '+'),
        //     '*',
        //     'quantity'
        //   );
        // } else {
        //   this.max = row.productQuantity;
        // }
        this.priceInfo = {
          realPrice: null,
          contractNo: this.$route.query.contractNo,
          contractDetailNo: row.contractDetailNo,
          pricingRule: pricingRule,
          tenantCode: this.userInfo.tenantCode,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          productNo: row.productNo,
          productDesc: row.productDesc,
          productUnit: row.unit,
          productUnitName: row.unitName,
          salesUnitPrice: row.businessContractUnitPrice,
          operatorNo: this.userInfo.userCode,
          operatorName: this.userInfo.userName,
          contractMatter: row.parentProductNo,
          contractMatterName: row.productChName,
          materialTypeName: this.materialTypeList?.find((item) => item.value == row.materialType)
            ?.label,
          materialType: row.materialType ? row.materialType : null,
          productQuantity: row.productQuantity,
          version: row.version,
          pricingFormula: row.gapRange || '',
          // operatorNo: this.userInfo.userCode,
          // operatorName: this.userInfo.userName,
        };
        // this.type = type;
        // if (this.type == '1') {
        //   delete this.priceInfo.productQuantity;
        // }
        // if (this.$refs['priceDialog']) {
        //   this.$refs['priceDialog'].resetFields();
        // }
        // 打开弹框
        this.dialogVisible = true;
      },
      getOrderPriceDetail(contractDetailNo, version) {
        this.$axios
          .post(API.UPDATE_ORDERSALEDETAIL_API, {
            contractNo: this.$route.query.contractNo,
            contractDetailNo: contractDetailNo,
            version: version,
          })
          .then((res) => {
            if (0 != res.data.code) {
              this.$alert(res.data.msg);
            } else {
              //更新父组件的最新变动价格
              this.$emit('updateProduct', {
                prop: 'priceChange',
                val: { ...res.data.data, temporaryPrice: this.priceInfo.temporaryPrice },
              });
              this.$message.success('改价成功');
              this.cancelHandler();
            }
          });
      },
      cancelHandler() {
        this.dialogVisible = false;
      },
      confirmHandler() {
        this.$refs.priceRef.validate((valid) => {
          if (valid) {
            this.$confirm('确定变更单价吗', '确认提示', {
              cancelButtonText: '取消',
              confirmButtonText: '确认',
              customClass: 'salePurchaseBox',
              center: true,
            }).then(() => {
              //确认变更单价
              console.log(this.priceInfo);
              this.$axios
                .post(API.SAVE_ORDERPRICE_API, {
                  ...this.priceInfo,
                  productQuantity: (+this.priceInfo.productQuantity).toFixed(8),
                  temporaryPrice: (+this.priceInfo.temporaryPrice).toFixed(4),
                  dataGroup: 'wm',
                })
                .then((res) => {
                  if (0 != res.data.code) {
                    this.$alert(res.data.msg);
                    this.cancelHandler();
                  } else {
                    console.log('成功');
                    this.getOrderPriceDetail(
                      this.priceInfo.contractDetailNo,
                      this.priceInfo.version
                    );
                  }
                });
            });
          }
        });
      },
    },
    mounted() {
      // 料型下拉框
      this.materialTypeList = this.dictListMap.materialType;
    },
  };
</script>

<style lang="scss" scoped></style>
